import { ACTION_TYPE } from 'rwl-shared/dist/models/EngagementEvent';
import { EngagementEvent } from 'rwl-shared/dist/models';

export const DEFAULT_QUEUE_KEY = 'rwl:session:events';

const viewedIds = new Set<string>();

export class EngagementQueue {
    private readonly storage: Storage;
    private readonly key: string;

    constructor(sessionStorage: Storage, key: string = DEFAULT_QUEUE_KEY) {
        this.storage = sessionStorage;
        this.key = key;
    }

    getKey(): string {
        return this.key;
    }

    hasSeenEventBefore(event: EngagementEvent): boolean {
        if (event.type === 'Conversion') {
            return false;
        }
        // allow for multiple clicks on a page load
        if (event.actionType !== ACTION_TYPE.VIEW) {
            return false;
        }

        // This will dedupe all events since the page was loaded
        if (event.contentId) {
            if (viewedIds.has(event.contentId)) {
                return true;
            } else {
                viewedIds.add(event.contentId);
                return false;
            }
        }

        if (event.mediaId) {
            if (viewedIds.has(event.mediaId)) {
                return true;
            } else {
                viewedIds.add(event.mediaId);
                return false;
            }
        }

        if (event.propertyId) {
            if (viewedIds.has(event.propertyId)) {
                return true;
            } else {
                viewedIds.add(event.propertyId);
                return false;
            }
        }

        if (event.workSiteId) {
            if (viewedIds.has(event.workSiteId)) {
                return true;
            } else {
                viewedIds.add(event.workSiteId);
                return false;
            }
        }

        return false;
    }

    addToQueue(event: EngagementEvent): number {
        const currentQueue = this.getQueue();
        if (this.hasSeenEventBefore(event)) {
            return currentQueue.length;
        }

        currentQueue.push(event);
        this.persistQueue(currentQueue);
        return currentQueue.length;
    }

    getQueue(): EngagementEvent[] {
        const current = this.storage.getItem(this.key);
        if (!current) {
            return [];
        }
        return JSON.parse(current);
    }

    persistQueue(queue: EngagementEvent[]): void {
        this.storage.setItem(this.key, JSON.stringify(queue));
    }

    clearQueue(): void {
        this.persistQueue([]);
    }

    clearViewedIds(): void {
        viewedIds.clear();
    }
}
